import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconBoldAdd = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="apricot">
      <Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 4.53882 4.53882 1 12 1C19.4612 1 23 4.53882 23 12C23 19.4612 19.4612 23 12 23C4.53882 23 1 19.4612 1 12ZM11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H11V9Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
